/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_sg_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Turn any title or text into a clean URL slug — lowercase, accents removed, spaces and punctuation replaced with a separator.`)
};

const es_sg_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Convierte cualquier título o texto en un slug de URL limpio — minúsculas, acentos eliminados, espacios y puntuación reemplazados con un separador.`)
};

const de_sg_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verwandeln Sie jeden Titel oder Text in einen sauberen URL-Slug — Kleinbuchstaben, Akzente entfernt, Leerzeichen und Satzzeichen durch ein Trennzeichen ersetzt.`)
};

const nl_sg_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zet elke titel of tekst om in een schone URL slug — kleine letters, accenten verwijderd, spaties en leestekens vervangen door een scheidingsteken.`)
};

const fr_sg_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Transformez n'importe quel titre ou texte en un slug URL propre — minuscules, accents supprimés, espaces et ponctuation remplacés par un séparateur.`)
};

const it_sg_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trasforma qualsiasi titolo o testo in uno slug URL pulito — minuscolo, accenti rimossi, spazi e punteggiatura sostituiti con un separatore.`)
};

const pt_br2_sg_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Transforme qualquer título ou texto em um slug de URL limpo — minúscula, acentos removidos, espaços e pontuação substituídos por um separador.`)
};

const pt_sg_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Transforme qualquer título ou texto num slug de URL limpo — minúsculas, acentos removidos, espaços e pontuação substituídos por um separador.`)
};

const ja_sg_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`任意のタイトルやテキストをクリーンなURLスラグに変換します — 小文字化、アクセント記号削除、スペースと句読点をセパレータで置き換え。`)
};

const zh_sg_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`将任意标题或文本转换为简洁的 URL slug——转为小写，去除重音符号，将空格和标点替换为分隔符。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const sg_intro = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.sg_intro(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("sg_intro", locale)
	if (locale === "en") return en_sg_intro(inputs)
	if (locale === "es") return es_sg_intro(inputs)
	if (locale === "de") return de_sg_intro(inputs)
	if (locale === "nl") return nl_sg_intro(inputs)
	if (locale === "fr") return fr_sg_intro(inputs)
	if (locale === "it") return it_sg_intro(inputs)
	if (locale === "pt-BR") return pt_br2_sg_intro(inputs)
	if (locale === "pt") return pt_sg_intro(inputs)
	if (locale === "ja") return ja_sg_intro(inputs)
	return zh_sg_intro(inputs)
};